
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Emit, Prop} from 'vue-property-decorator';

  @Component({})
  export default class ChallengeDialogNoProfile extends Vue {
    @Prop({required: true, default: false}) open!: boolean;
    @Prop({required: false, default: true}) isChallenge!: boolean;

    @Emit('onSuccess')
    onSuccess() { /**/
    }

    @Emit('onCancel')
    onCancel() { /**/
    }
  }

